// @ts-check
import { gql } from '@apollo/client';
import { BottlebooksLogomark, Image, Box } from '~/design-system';

export default function CompanyLogo({ company, ...rest }) {
  return company?.logo?.fixed ? (
    <Image
      fixed={company?.logo?.fixed}
      alt={company?.name}
      // Make sure that images have a set width so that content always aligns
      sx={{ display: 'block', overflow: 'hidden', width: 60, height: 60 }}
      fallback={<Box sx={{ width: 60, height: 60 }} />}
      {...rest}
    />
  ) : (
    <BottlebooksLogomark sx={{ color: 'brand.gray', width: 60, height: 60 }} />
  );
}

CompanyLogo.fragment = gql`
  fragment CompanyLogo on Profile {
    logo {
      fixed(width: 60, height: 60, crop: PAD, fetch_format: AUTO) {
        ...fixedImage
      }
    }
  }
  ${Image.fixedImage}
`;
